















































































import { Component, Vue } from 'vue-property-decorator'
import { getLocalItem } from '@/utils'
import MainHeader from '@/components/MainHeader'
import EnergySaving from './components/EnergySaving.vue'
import ConsumptionSanking from './components/ConsumptionSanking.vue'
import Consumption from './components/Consumption.vue'
import ConsumptionStructure from './components/ConsumptionStructure.vue'
import EnergyConsumption from './components/EnergyConsumption.vue'
import IndustrialOutput from './components/IndustrialOutput.vue'
import Map from './components/map/index.vue'
import GlobalFooter from '@/components/GlobalFooter'

@Component({
  components: {
    MainHeader,
    EnergySaving,
    ConsumptionSanking,
    Consumption,
    ConsumptionStructure,
    EnergyConsumption,
    IndustrialOutput,
    Map,
    GlobalFooter,
  },
})
export default class Home extends Vue {
  private update: Boolean = true;
  private screenWidth: any = 1920;
  private screenHeight: any = 1080;
  private widthRate: any = 1;
  private heightRata: any = 1;
  private allWidth: any = 0;
  private height: any = null;
  private width: any = null;
  private id: any = '';
  private area: string = getLocalItem('client').regionName;
  private areaCode: string = getLocalItem('client').custRegionCode;
  private client: any = getLocalItem('client');
  private Timefun() {
    const now = new Date()
    let yy = now.getFullYear() //年
    const mm = now.getMonth() + 1 //月
    // const dd = now.getDate() //日
    // let hh = now.getHours() //时
    // let ii = now.getMinutes() //分
    // let ss = now.getSeconds() //秒
    if (mm == 1) {
      yy--
    }

    var clock = ''
    clock +=
      yy +
      '年 ' +
      '1月' +
      (mm == 1 ? '-12月' : mm == 2 ? '' : '-' + (mm - 1) + '月')
    return clock
  }
  Reloadfun() {
    (this.$refs['Map'] as Map).nomole({}),
      this.cllbanck({
        regionCode: this.client.custRegionCode,
        regionName: this.client.regionName,
      })
  }
  cllbanck(e: any) {
    this.area = e.regionName
    this.areaCode = e.regionCode
  }
  mounted() {
    // this.FullContainer('home')
  }
}
